import * as yup from "yup";

export const schemaErrorsProfile = yup.object().shape({
  name: yup.string().required("Nome não pode ficar em branco."),
  username: yup.string().required("Username não pode ficar em branco."),
  biography: yup.string().required("Username não pode ficar em branco."),
});
